module.exports = __webpack_public_path__ + "static/5-fe5e14c8f196dbe2bf83a5b18363fd73.jpg";